import {API, instance} from "../const/api";
import {ResponseData} from "./utility";





export async function refreshToken( Calback) {

    /*const token =  localStorage.getItem("token")
    if(token){
        await instance.post(API.refreshToken, )
            .then(function (response) {
                Calback(response)
            })
            .catch(function (error) {
                Calback(error.response);
            });
    }else{
        localStorage.clear();
        window.location.reload();
    }*/
    console.log(Calback);
}
export async function CheckrefreshToken( ) {

    const token =  localStorage.getItem("token")

    if(token){
        refreshToken((response)=>{



            const {status, data} = ResponseData(response)
            switch (status){
                case 200:
                    console.log(data);
                    break;
                case 201:
                    localStorage.setItem('token',data.token)
                    break;
                case 401:
                    localStorage.clear();
                    window.location.reload();
                    break;
                default:
                    break;
            }
        })
    }else{
        localStorage.clear();
        window.location = "/login"
    }


}


export async function GetCode(params,Calback) {
    CheckrefreshToken();
    await instance.get(API.Code,{
        params
    })
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}

export async function PostCode(params,Calback) {
    CheckrefreshToken();
    await instance.post(API.Code,params,{
        timeout:100000
    })
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function Approve(params, Calback) {
    CheckrefreshToken();
    await instance.post(API.Approve, params)
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}


export async function CheckCode(code,Calback) {
    CheckrefreshToken();
    await instance.post(API.Check+"/"+code,{

    })
        .then(function (response) {
            Calback(response)
        })
        .catch(function (error) {
            Calback(error.response);
        });
}



